<template>
  <el-dialog
    title="授权证书模板配置说明"
    :visible.sync="visible"
    width="60%"
    :before-close="handleClose"
  >
    <div class="help-content">
      
      <!-- 占位符列表 -->
      <el-card class="help-section">
        <div slot="header">
          <i class="el-icon-document-copy"></i>
          模板占位符说明
        </div>
        
        <p class="section-desc">在授权证书模板中，请将以下占位符放置在需要替换的位置：</p>
        
        <el-table :data="placeholders" border style="width: 100%">
          <el-table-column prop="placeholder" label="占位符" width="200">
            <template slot-scope="scope">
              <el-tag type="primary">{{ scope.row.placeholder }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="说明" />
          <el-table-column prop="required" label="必填" width="80" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.required ? 'danger' : 'info'" size="mini">
                {{ scope.row.required ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      
      <!-- 配置说明 -->
      <el-card class="help-section">
        <div slot="header">
          <i class="el-icon-setting"></i>
          模板配置说明
        </div>
        
        <div class="config-steps">
          <el-steps :active="4" direction="vertical">
            <el-step title="准备模板文件" description="创建Word文档，设计证书样式和布局" />
            <el-step title="添加占位符" description="在需要动态内容的位置插入上述占位符" />
            <el-step title="上传模板" description="将模板文件命名为'授权证书模板.docx'并放置在服务器指定目录" />
            <el-step title="测试生成" description="使用系统功能测试证书生成是否正常" />
          </el-steps>
        </div>
      </el-card>
      
      <!-- 注意事项 -->
      <el-card class="help-section">
        <div slot="header">
          <i class="el-icon-warning"></i>
          重要注意事项
        </div>
        
        <el-alert
          title="占位符格式要求"
          type="warning"
          description="占位符必须完整放置在同一段落或表格单元格中，避免被Word拆分。建议在替换前取消模板内的自动换行、自动编号等特殊格式。"
          show-icon
          :closable="false"
        />
        
        <div class="tips-list">
          <el-tag effect="plain" class="tip-item">
            <i class="el-icon-check"></i>
            日期字段会自动转换为中文格式（如：2024年1月1日）
          </el-tag>
          <el-tag effect="plain" class="tip-item">
            <i class="el-icon-check"></i>
            模板文件支持图片、表格、特殊格式等Word功能
          </el-tag>
          <el-tag effect="plain" class="tip-item">
            <i class="el-icon-check"></i>
            生成的证书文件可直接下载使用
          </el-tag>
        </div>
      </el-card>
      
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">知道了</el-button>
      <el-button type="primary" @click="copyPlaceholders">
        <i class="el-icon-document-copy"></i>
        复制所有占位符
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CertificateTemplateHelp',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      placeholders: [
        { placeholder: '${authorizedName}', description: '被授权人姓名', required: true },
        { placeholder: '${certificateNo}', description: '证书编号（系统自动生成，格式：ZDT000001）', required: true },
        { placeholder: '${role}', description: '授权角色（总代/代理等）', required: true },
        { placeholder: '${wechatId}', description: '被授权人微信号', required: true },
        { placeholder: '${authorizedPhone}', description: '被授权人联系电话', required: false },
        { placeholder: '${authorizedRegion}', description: '授权区域', required: false },
        { placeholder: '${authorizedIdNumber}', description: '被授权人证件号', required: false },
        { placeholder: '${startDate}', description: '授权开始日期', required: true },
        { placeholder: '${endDate}', description: '授权结束日期', required: true },
        { placeholder: '${issuer}', description: '授权单位', required: true }
      ]
    }
  },
  
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    
    // 复制所有占位符
    copyPlaceholders() {
      const placeholderText = this.placeholders
        .map(item => `${item.placeholder} - ${item.description}`)
        .join('\n')
      
      // 创建临时文本区域
      const textArea = document.createElement('textarea')
      textArea.value = placeholderText
      document.body.appendChild(textArea)
      textArea.select()
      
      try {
        document.execCommand('copy')
        this.$message.success('占位符列表已复制到剪贴板')
      } catch (error) {
        this.$message.error('复制失败，请手动复制')
      }
      
      document.body.removeChild(textArea)
    }
  }
}
</script>

<style scoped>
.help-content {
  max-height: 70vh;
  overflow-y: auto;
}

.help-section {
  margin-bottom: 20px;
  border-radius: 8px;
}

.help-section:last-child {
  margin-bottom: 0;
}

.section-desc {
  margin-bottom: 15px;
  color: #666;
  line-height: 1.6;
}

.config-steps {
  padding: 10px 0;
}

.tips-list {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tip-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e0e6ed;
  border-radius: 6px;
  background: #fafbfc;
}

.tip-item i {
  color: #67c23a;
}

.dialog-footer .el-button {
  margin-left: 10px;
}
</style>
